import { render, staticRenderFns } from "./FaleConoscoView.vue?vue&type=template&id=cbc9e8e0&"
import script from "./faleconosco.js?vue&type=script&lang=js&"
export * from "./faleconosco.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports